import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PreCashinInfo } from '../../../../../types/Cashier';
import { isSingleTicket } from '../../../../../utils/bonus';
import TicketSetRecord from '../TicketSetRecord/TicketSetRecord';

import {
  TXTCLI_CongratulationsX,
  TXTCLI_CongratulationsX_Once_your_dep_ELL,
  TXTCLI_Your_N0_deposit_earns_you_an_I_ELL,
  TXTCLI_Your_deposit_of_N0_has_allowed_ELL,
  TXTWCL_You_can_view_your_available_to_ELL,
  TXTWCL_You_can_view_your_available_to_ELL_1
} from './InstantCashAndTournamentBonus.messages.json';

const InstantCashAndTournamentBonus: React.FC = () => {
  const {
    data: { preCashinInfo },
    values: {
      deposit: { currency }
    }
  } = useWizardContext();

  const { balanceAmount, bonusCurrency, bonusMax, bonusPercent, potentialBonusAmount } =
    preCashinInfo as PreCashinInfo;

  return bonusMax || bonusPercent ? (
    <Translation
      tagName="p"
      {...TXTCLI_Your_N0_deposit_earns_you_an_I_ELL}
      values={{
        0: <CurrencyAmount value={balanceAmount} currency={currency} />,
        1: (
          <CurrencyAmount
            value={Math.min(bonusMax, potentialBonusAmount)}
            currency={bonusCurrency}
          />
        )
      }}
    />
  ) : isSingleTicket(preCashinInfo as PreCashinInfo) ? (
    <>
      <Translation
        tagName="p"
        {...TXTCLI_CongratulationsX_Once_your_dep_ELL}
        values={{
          0: <CurrencyAmount value={balanceAmount} currency={currency} />
        }}
      />
      <Translation tagName="p" {...TXTWCL_You_can_view_your_available_to_ELL_1} />
    </>
  ) : (
    <>
      <Translation tagName="p" {...TXTCLI_CongratulationsX} />
      <Translation
        tagName="p"
        {...TXTCLI_Your_deposit_of_N0_has_allowed_ELL}
        values={{
          0: <CurrencyAmount value={balanceAmount} currency={currency} />
        }}
      />
      <TicketSetRecord ticketSet={preCashinInfo?.ticketSet} />
      <Translation tagName="p" {...TXTWCL_You_can_view_your_available_to_ELL} />
    </>
  );
};
export default InstantCashAndTournamentBonus;
